import { Routes } from '@angular/router';
import { AuthComponent } from './pages/auth/auth.component';
import { HomeComponent } from './pages/home/home.component';
import { FeedComponent } from './pages/feed/feed.component';
import { JobsComponent } from './pages/jobs/jobs.component';
import { JobDetailComponent } from './pages/job-detail/job-detail.component';
import { ChatsComponent } from './pages/chats/chats.component';
import { ChatDetailComponent } from './pages/chat-detail/chat-detail.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { FollowersComponent } from './pages/followers/followers.component';
import { FollowingComponent } from './pages/following/following.component';
import { ConferenceComponent } from './pages/conference/conference.component';
import { AttendeesListComponent } from './pages/attendees-list/attendees-list.component';
import { VendorListComponent } from './pages/vendor-list/vendor-list.component';
import { SessionListComponent } from './pages/session-list/session-list.component';
import { ConferenceLogListComponent } from './pages/conference-log-list/conference-log-list.component';
import { ConnectionsComponent } from './pages/connections/connections.component';
import { ConferenceDetailComponent } from './pages/conference-detail/conference-detail.component';
import { PostEditComponent } from './pages/post-edit/post-edit.component';
import { OrganizationComponent } from './pages/organization/organization.component';
import { PathwayPattyComponent } from './pages/pathway-patty/pathway-patty.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: FeedComponent,
    canActivate: [authGuard],
    title: 'Dashboard',
    data: {
      title: 'Dashboard',
      icon: 'pi pi-home',
      breadcrumb: [
        {
          label: 'Dashboard',
          routerLink: ['/'],
          icon: 'pi pi-home',
        },
      ],
    },
  },
  {
    path: 'home',
    component: HomeComponent,
    data: {
      title: 'Home',
      icon: 'pi pi-home',
      breadcrumb: [
        { label: 'Home', routerLink: ['/home'], icon: 'pi pi-home' },
      ],
    },
    canActivate: [authGuard],
  },
  {
    path: 'auth',
    component: AuthComponent,
  },
  {
    path: 'feed',
    component: FeedComponent,
    canActivate: [authGuard],
    title: 'Feed',
    data: {
      title: 'Feed',
      icon: 'pi pi-home',
      breadcrumb: [
        { label: 'Feed', routerLink: ['/feed'], icon: 'pi pi-home' },
      ],
    },
  },
  {
    path: 'post/new',
    component: PostEditComponent,
    canActivate: [authGuard],
    title: 'Create a Post',
    data: {
      title: 'Create a Post',
      icon: 'pi pi-pencil',
      breadcrumb: [
        { label: 'Feed', routerLink: ['/feed'], icon: 'pi pi-home' },
        {
          label: 'Create a Post',
          routerLink: ['/post/new'],
          icon: 'pi pi-pencil',
        },
      ],
    },
  },
  {
    path: 'post/:id',
    component: PostEditComponent,
    canActivate: [authGuard],
    title: 'Edit Post',
    data: {
      title: 'Edit Post',
      icon: 'pi pi-pencil',
      breadcrumb: [
        { label: 'Feed', routerLink: ['/feed'], icon: 'pi pi-home' },
        {
          label: 'Edit Post',
          routerLink: ['/post', ':id'],
          icon: 'pi pi-pencil',
        },
      ],
    },
  },
  {
    path: 'jobs',
    component: JobsComponent,
    canActivate: [authGuard],
    title: 'Jobs',
    data: {
      title: 'Jobs',
      icon: 'pi pi-briefcase',
      breadcrumb: [
        { label: 'Jobs', routerLink: ['/jobs'], icon: 'pi pi-briefcase' },
      ],
    },
  },
  {
    path: 'jobs/:id',
    component: JobDetailComponent,
    canActivate: [authGuard],
    title: 'Job Details',
    data: {
      title: 'Job Details',
      icon: 'pi pi-briefcase',
      breadcrumb: [
        { label: 'Jobs', routerLink: ['/jobs'], icon: 'pi pi-briefcase' },
        {
          label: 'Job Details',
          routerLink: ['/jobs', ':id'],
          icon: 'pi pi-briefcase',
        },
      ],
    },
  },
  {
    path: 'chats',
    component: ChatsComponent,
    canActivate: [authGuard],
    title: 'Chats',
    data: {
      title: 'Chats',
      icon: 'pi pi-comments',
      breadcrumb: [
        { label: 'Chats', routerLink: ['/chats'], icon: 'pi pi-comments' },
      ],
    },
  },
  {
    path: 'chats/:id',
    component: ChatDetailComponent,
    canActivate: [authGuard],
    title: 'Chat',
    data: {
      title: 'Chat',
      icon: 'pi pi-comments',
      breadcrumb: [
        { label: 'Chats', routerLink: ['/chats'], icon: 'pi pi-comments' },
        {
          label: 'Chat',
          routerLink: ['/chats', ':id'],
          icon: 'pi pi-comments',
        },
      ],
    },
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [authGuard],
    title: 'Profile',
    data: {
      title: 'Profile',
      icon: 'pi pi-user',
      breadcrumb: [
        { label: 'Profile', routerLink: ['/profile'], icon: 'pi pi-user' },
      ],
    },
  },
  {
    path: 'profile/:userId',
    component: ProfileComponent,
    canActivate: [authGuard],
    title: 'User Profile',
    data: {
      title: 'User Profile',
      icon: 'pi pi-user',
      breadcrumb: [
        { label: 'Profile', routerLink: ['/profile'], icon: 'pi pi-user' },
        {
          label: 'User Profile',
          routerLink: ['/profile', ':userId'],
          icon: 'pi pi-user',
        },
      ],
    },
  },
  {
    path: 'profile/followers',
    component: FollowersComponent,
    canActivate: [authGuard],
    title: 'Followers',
    data: {
      title: 'Followers',
      icon: 'pi pi-users',
      breadcrumb: [
        { label: 'Profile', routerLink: ['/profile'], icon: 'pi pi-user' },
        {
          label: 'Followers',
          routerLink: ['/profile/followers'],
          icon: 'pi pi-users',
        },
      ],
    },
  },
  {
    path: 'profile/following',
    component: FollowingComponent,
    canActivate: [authGuard],
    title: 'Following',
    data: {
      title: 'Following',
      icon: 'pi pi-user-plus',
      breadcrumb: [
        { label: 'Profile', routerLink: ['/profile'], icon: 'pi pi-user' },
        {
          label: 'Following',
          routerLink: ['/profile/following'],
          icon: 'pi pi-user-plus',
        },
      ],
    },
  },
  {
    path: 'conference',
    component: ConferenceComponent,
    canActivate: [authGuard],
    title: 'Conferences',
    data: {
      title: 'Conferences',
      icon: 'pi pi-calendar',
      breadcrumb: [
        {
          label: 'Conferences',
          routerLink: ['/conference'],
          icon: 'pi pi-calendar',
        },
      ],
    },
  },
  {
    path: 'conference/:id',
    component: ConferenceDetailComponent,
    canActivate: [authGuard],
    title: 'Conference Details',
    data: {
      title: 'Conference Details',
      icon: 'pi pi-calendar',
      breadcrumb: [
        {
          label: 'Conferences',
          routerLink: ['/conference'],
          icon: 'pi pi-calendar',
        },
        {
          label: 'Conference Details',
          routerLink: ['/conference', ':id'],
          icon: 'pi pi-calendar',
        },
      ],
    },
  },
  {
    path: 'conference/:conferenceId/attendees',
    component: AttendeesListComponent,
    canActivate: [authGuard],
    title: 'Attendees',
    data: {
      title: 'Attendees',
      icon: 'pi pi-users',
      breadcrumb: [
        {
          label: 'Conferences',
          routerLink: ['/conference'],
          icon: 'pi pi-calendar',
        },
        {
          label: 'Attendees',
          routerLink: ['/conference', ':conferenceId', 'attendees'],
          icon: 'pi pi-users',
        },
      ],
    },
  },
  {
    path: 'conference/:conferenceId/vendors',
    component: VendorListComponent,
    canActivate: [authGuard],
    title: 'Vendors',
    data: {
      title: 'Vendors',
      icon: 'pi pi-building',
      breadcrumb: [
        {
          label: 'Conferences',
          routerLink: ['/conference'],
          icon: 'pi pi-calendar',
        },
        {
          label: 'Vendors',
          routerLink: ['/conference', ':conferenceId', 'vendors'],
          icon: 'pi pi-building',
        },
      ],
    },
  },
  {
    path: 'conference/:conferenceId/sessions',
    component: SessionListComponent,
    canActivate: [authGuard],
    title: 'Sessions',
    data: {
      title: 'Sessions',
      icon: 'pi pi-calendar-times',
      breadcrumb: [
        {
          label: 'Conferences',
          routerLink: ['/conference'],
          icon: 'pi pi-calendar',
        },
        {
          label: 'Sessions',
          routerLink: ['/conference', ':conferenceId', 'sessions'],
          icon: 'pi pi-calendar-times',
        },
      ],
    },
  },
  {
    path: 'conference/:conferenceId/logs',
    component: ConferenceLogListComponent,
    canActivate: [authGuard],
    title: 'Conference Logs',
    data: {
      title: 'Conference Logs',
      icon: 'pi pi-file',
      breadcrumb: [
        {
          label: 'Conferences',
          routerLink: ['/conference'],
          icon: 'pi pi-calendar',
        },
        {
          label: 'Conference Logs',
          routerLink: ['/conference', ':conferenceId', 'logs'],
          icon: 'pi pi-file',
        },
      ],
    },
  },
  {
    path: 'conference/:conferenceId/connections',
    component: ConnectionsComponent,
    canActivate: [authGuard],
    title: 'Connections',
    data: {
      title: 'Connections',
      icon: 'pi pi-link',
      breadcrumb: [
        {
          label: 'Conferences',
          routerLink: ['/conference'],
          icon: 'pi pi-calendar',
        },
        {
          label: 'Connections',
          routerLink: ['/conference', ':conferenceId', 'connections'],
          icon: 'pi pi-link',
        },
      ],
    },
  },
  {
    path: 'organization/:id',
    component: OrganizationComponent,
    canActivate: [authGuard],
    title: 'Organization',
    data: {
      title: 'Organization',
      icon: 'pi pi-building',
      breadcrumb: [
        {
          label: 'Organization',
          routerLink: ['/organization', ':id'],
          icon: 'pi pi-building',
        },
      ],
    },
  },
  {
    path: 'pathway-patty',
    component: PathwayPattyComponent,
    canActivate: [authGuard],
    title: 'Pathway Patty',
    data: {
      title: 'Pathway Patty',
      icon: 'pi pi-comments',
      breadcrumb: [
        {
          label: 'Pathway Patty',
          routerLink: ['/pathway-patty'],
          icon: 'pi pi-comments',
        },
      ],
    },
  },
];
